export default __webpack_public_path__ + "static/media/payment.45e697eb.svg";